import {Types} from "../../../type/Types";

export type ShoppingParticipationValueObject = {
    id: bigint
    shoppingPathJointId: bigint
    userId: bigint
    mediaId: string
    mediaCode: string | null
    mid: string
    answer: string | null
    isVerified: boolean | null
    isPassed: boolean
    isExhausted: boolean
    isPostBackSuccess: boolean
    createdAt: Date
    modifiedAt: Date | null
    deletedAt: Date | null
}

export namespace ShoppingParticipationValueObject {
    export function construct(o: any): ShoppingParticipationValueObject {
        return {
            id: BigInt(o.id),
            shoppingPathJointId: BigInt(o.shoppingPathJointId),
            userId: BigInt(o.userId),
            mediaId: String(o.mediaId),
            mediaCode: Types.asNull(o.mediaCode,String),
            mid: String(o.mid),
            answer: Types.asNull(o.answer, String),
            isVerified: Types.asNull(o.isVerified, Boolean),
            isPassed: Boolean(o.isPassed),
            isExhausted: Boolean(o.isExhausted),
            isPostBackSuccess: Boolean(o.isPostBackSuccess),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof ShoppingParticipationValueObject, string> = {
        id: 'ID',
        shoppingPathJointId: '쇼핑 경로 Joint ID',
        userId: '사용자 ID',
        mediaId: '미디어 ID',
        mediaCode: '미디어코드',
        mid: '상품 미드값',
        answer: '미션 정답',
        isVerified: '검증된 참가자',
        isPassed: '통과 여부',
        isExhausted: '소진 여부',
        isPostBackSuccess: '포스트백 여부',
        createdAt: '생성 시각',
        modifiedAt: '수정 시각',
        deletedAt: '삭제 시각',
    }
}